// src/main.jsx — v9.2 FIXED
//
// ИСПРАВЛЕНИЕ ПОРЯДКА ИМПОРТОВ CSS — причина белого фона:
//
// БЫЛО (неправильно):
//   import './styles/global.css';   ← global.css загружается первым
//   import './styles/tokens.css';   ← токены ещё не определены!
//
// global.css содержит внутри: @import "./tokens.css"
// НО Vite/bundler при двойном импорте одного файла делает deduplication:
// он видит что tokens.css уже импортирован в main.jsx ПОСЛЕ global.css
// и убирает @import из global.css (считает дублем).
// В итоге global.css применяется ДО определения CSS variables → белый фон.
//
// СТАЛО (правильно):
//   import './styles/tokens.css';   ← ПЕРВЫМ: определяем все --variables
//   import './styles/global.css';   ← ВТОРЫМ: используем --variables
//
// АЛЬТЕРНАТИВА (тоже правильно): убрать оба из main.jsx и оставить только
// @import внутри global.css — но тогда нужно убрать @import tailwindcss из global.css
// (несовместимо с Vite в некоторых конфигурациях).

import './styles/tokens.css';   // ПЕРВЫМ — определяем все CSS-переменные
import './styles/global.css';   // ВТОРЫМ — используем переменные

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App.jsx';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
